module.exports = __webpack_public_path__ + "img/BW.4198120e.svg";